import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { SelectField } from '../components/Table/fields/SelectField';
import { Rate } from '../types/entities/Rate';
import { DateField } from '../components/Table/fields/DateField';

export const rate: SchemaWithClient<Rate> = {
  name: 'Rate',
  pluralName: 'Rate',
  columns: {
    currency: {
      name: 'Currency',
      required: true,
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      switchboard: true,
    },
    value: {
      name: 'Value',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    date: {
      name: 'Date',
      fieldRenderer: DateField,
      fieldType: 'date',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/rates'),
};
